module.exports = __webpack_public_path__ + "img/horlicks.1e9755ee.jpg";